import { useFingerprint, useNotificationPermission } from "@hooks";
import { useStore } from "@stores";
import { useEffect } from "react";

type UserStore = ReturnType<typeof useStore>["userStore"];

/**
 * Pita Firebase za token ovog uređaja i šalje ga serveru, vezanog za otisak uređaja i
 * korisnika. Token se čeka, a ne čita iz localStorage-a, pa se nikad ne pošalje star.
 */
export const registerFirebaseToken = async (
  userStore: UserStore,
  fingerprint: string,
) => {
  let token: string | undefined;
  try {
    // Dinamički uvoz: firebase (~40 KB gzip) ne treba anonimnim posetiocima.
    const { getFirebaseToken } = await import("../../firebase");
    token = await getFirebaseToken();
  } catch (err) {
    // Pretraživač bez podrške za FCM (npr. iOS Safari van PWA) — bez push-a.
    console.warn("Firebase messaging nije dostupan.", err);
    return;
  }
  if (token) userStore.createFirebaseToken({ token, fingerprint });
};

/**
 * Registruje uređaj kad je korisnik prijavljen i dozvola data. Ponavlja se čim dozvola
 * postane `granted` (prozor pri prijavi, dugme, podešavanja pregledača), bez ponovnog
 * učitavanja stranice.
 */
export const useFirebaseToken = () => {
  const { authStore, userStore } = useStore();
  const fingerprint = useFingerprint();
  const { status } = useNotificationPermission();
  const userId = authStore.currentUserId;

  useEffect(() => {
    if (!userId || !fingerprint || status !== "granted") return;

    registerFirebaseToken(userStore, fingerprint);
  }, [userId, fingerprint, status, userStore]);
};
